import API from './api';
import { Image, ImageCreate } from '../types';
import { FluxImageGenerationRequest } from '../types';

export const getImages = async (tagIds?: string[]): Promise<Image[]> => {
  const params: any = {};
  if (tagIds && tagIds.length > 0) {
    params.tagIds = tagIds.join(',');
  }
  const response = await API().get('/images', { params });
  return response.data;
};

export const getPublicImages = async (tagIds?: string[]): Promise<Image[]> => {
  const params: any = {};
  if (tagIds && tagIds.length > 0) {
    params.tagIds = tagIds.join(',');
  }
  const response = await API().get('/images/public', { params });
  return response.data;
};

export const uploadImage = async (formData: FormData): Promise<Image> => {
  const response = await API().post('/images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteImage = async (imageId: string): Promise<void> => {
  await API().delete(`/images/${imageId}`);
};

export const makeImagePublic = async (imageId: string): Promise<Image> => {
  const response = await API().put(`/images/${imageId}/make-public`);
  return response.data;
};

export const generateImage = async (request: FluxImageGenerationRequest): Promise<{url: string, _id: string}> => {
  const response = await API().post('/images/generate', request);
  return response.data;
};

export const describeImageFromBase64 = async (base64Image: string, prompt?: string, lang?: string): Promise<string> => {
  const response = await API().post('/images/describe-base64', { base64Image, prompt, lang });
  return response.data.description;
};

export const describeImageById = async (imageId: string, prompt?: string, lang?: string): Promise<string> => {
  const response = await API().post(`/images/${imageId}/describe`, { prompt, lang });
  return response.data.description;
};

export const updateImageAlt = async (imageId: string, alt: string): Promise<Image> => {
  const response = await API().put(`/images/${imageId}/alt`, { alt });
  return response.data;
};

export const updateImage = async (imageId: string, type: string, alt: string, tagIds: string[], url: string): Promise<Image> => {
  const response = await API().put(`/images/${imageId}`, { type, alt, tagIds, url });
  return response.data;
};
